import { Link, useNavigate } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { BookOpen, FlaskConical, Users } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { FREE_PRACTICE, startPractice } from './practice/engine'

/** Learn's title with the Lessons / Team switch, like Action Items' Table / Queue. */
export function LearnHeader({ view }: { view: 'lessons' | 'team' }) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  // The whole dashboard on real data, with nothing saved: try anything without a lesson.
  const practise = () => {
    startPractice(FREE_PRACTICE, null)
    queryClient.removeQueries()
    void navigate({ to: '/dashboard' })
  }
  return (
    <div className="flex flex-wrap items-center justify-between gap-2">
      <div className="flex items-center gap-3">
        <h1 className="text-2xl font-bold tracking-tight">Learn</h1>
        <div role="group" aria-label="Learn view" className="inline-grid grid-cols-2 rounded-lg border bg-muted/40 p-1">
          {(
            [
              { value: 'lessons', label: 'Lessons', Icon: BookOpen, to: '/learn' },
              { value: 'team', label: 'Team', Icon: Users, to: '/learn/team' },
            ] as const
          ).map(({ value, label, Icon, to }) => (
            <Link
              key={value}
              to={to}
              aria-current={view === value ? 'page' : undefined}
              className={cn(
                'inline-flex min-h-8 items-center justify-center gap-2 rounded-md px-3 text-xs font-medium text-muted-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
                view === value && 'bg-background text-foreground shadow-sm',
              )}
            >
              <Icon className="size-3.5" aria-hidden="true" />
              {label}
            </Link>
          ))}
        </div>
      </div>
      <Button size="sm" variant="outline" onClick={practise}>
        <FlaskConical className="size-3.5" /> Practice mode
      </Button>
    </div>
  )
}
